/* React */
import React from 'react';

/* Hooks */
import { useWordle } from '../../../WordleContext';
import { Container } from './styles';

interface Props {
  isVisible: boolean
}

export const BorderOptions: React.FC<Props> = ({ isVisible }: Props) => {

  /* Context */
  const {
    setOpenModalBorderColor,
    setBorderColor
  } = useWordle();

  return (
    <Container isVisible={isVisible}>
      <div>
        <header>
          <h1>Escolha a coloração da borda que preferir:</h1>
          <button
            onClick={() => setOpenModalBorderColor(false)}
          >
            X
          </button>
        </header>
        <main>
          <button
            className='BluePurple'
            onClick={() => {
              setBorderColor('linear-gradient(to top, rgba(114, 209, 254,1), rgba(134,79,151,1))');
              setOpenModalBorderColor(false);
              localStorage.setItem('@portalWordle:borderColor', 'linear-gradient(to top, rgba(114, 209, 254,1), rgba(134,79,151,1))');
            }}
          >
            <h1>Azul/Roxo</h1>
          </button>
          <button
            className='YellowPurple'
            onClick={() => {
              setBorderColor('linear-gradient(to top, rgba(134,79,151,1), rgba(255,180,72,1))');
              setOpenModalBorderColor(false);
              localStorage.setItem('@portalWordle:borderColor', 'linear-gradient(to top, rgba(134,79,151,1), rgba(255,180,72,1))');
            }}
          >
            <h1>Amarelo/Roxo</h1>
          </button>
          <button
            className='RedPink'
            onClick={() => {
              setBorderColor('linear-gradient(to top, rgba(250,42,192,1) 0%, rgba(240,9,9,1) 100%)');
              setOpenModalBorderColor(false);
              localStorage.setItem('@portalWordle:borderColor', 'linear-gradient(to top, rgba(250,42,192,1) 0%, rgba(240,9,9,1) 100%)');
            }}
          >
            <h1>Vermelho/Rosa</h1>
          </button>
          <button
            className='BlueGreen'
            onClick={() => {
              setBorderColor('linear-gradient(to top, rgba(23,155,231,1) 0%, rgba(21,237,128,1) 100%)');
              setOpenModalBorderColor(false);
              localStorage.setItem('@portalWordle:borderColor', 'linear-gradient(to top, rgba(23,155,231,1) 0%, rgba(21,237,128,1) 100%)');
            }}
          >
            <h1>Azul/Verde</h1>
          </button>
          <button
            className='Fire'
            onClick={() => {
              setBorderColor('linear-gradient(to top, rgba(237,27,27,1) 12%, rgba(242,111,0,1) 52%, rgba(242,214,8,1) 87%)');
              setOpenModalBorderColor(false);
              localStorage.setItem('@portalWordle:borderColor', 'linear-gradient(to top, rgba(237,27,27,1) 12%, rgba(242,111,0,1) 52%, rgba(242,214,8,1) 87%)');
            }}
          >
            <h1>Vermelho/Amarelo</h1>
          </button>
          <button
            className='PinkGreen'
            onClick={() => {
              setBorderColor('linear-gradient(to top, rgba(233,11,189,1) 14%, rgba(9,240,65,1) 100%)');
              setOpenModalBorderColor(false);
              localStorage.setItem('@portalWordle:borderColor', 'linear-gradient(to top, rgba(233,11,189,1) 14%, rgba(9,240,65,1) 100%)');
            }}
          >
            <h1>Rosa/Verde</h1>
          </button>
          <button
            className='GrayCian'
            onClick={() => {
              setBorderColor('linear-gradient(to top, rgba(96,96,96,1) 30%, rgba(21,237,207,1) 100%)');
              setOpenModalBorderColor(false);
              localStorage.setItem('@portalWordle:borderColor', 'linear-gradient(to top, rgba(96,96,96,1) 30%, rgba(21,237,207,1) 100%)');
            }}
          >
            <h1>Cinza/Ciano</h1>
          </button>
          <button
            className='BluePink'
            onClick={() => {
              setBorderColor('linear-gradient(to top, rgba(34,150,245,1) 0%, rgba(250,78,221,1) 74%)');
              setOpenModalBorderColor(false);
              localStorage.setItem('@portalWordle:borderColor', 'linear-gradient(to top, rgba(34,150,245,1) 0%, rgba(250,78,221,1) 74%)');
            }}
          >
            <h1>Azul/Rosa</h1>
          </button>
        </main>
      </div>
    </Container>
  );
};
